import type { Article } from "@/types/content";

export const industryArticles: Article[] = [
  {
    id: "i01",
    section: "industry",
    category: "行业",
    title: "工信部发布新能源汽车产业发展新规划",
    summary: "新一轮产业规划聚焦技术创新、补能体系与供应链安全，为未来几年产业发展指明方向。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20clean%20modern%20government%20conference%20hall%20with%20flag%20and%20podium%2C%20soft%20daylight%2C%20clean%20neutral%20architectural%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20formal%20tones&width=800&height=600&seq=ind-01&orientation=landscape",
    author: "行业组 · 编辑部",
    date: "2026-10-12",
    readTime: 5,
    views: 18240,
    tags: ["行业", "政策", "新能源", "规划"],
    brand: "政策",
    level: "宏观",
    content: [
      "相关部门发布新能源汽车产业发展的新一轮规划，明确未来数年产业发展的总体目标与重点任务，涵盖技术创新、基础设施建设与供应链安全等多个方面。",
      "规划提出，要继续推动电池、电驱与智能驾驶等关键技术的自主突破，同时加快充电与换电基础设施的布局，提升补能便利性。",
      "此外，规划还强调产业链与供应链的稳定性，鼓励企业加强协同，推动产业向高质量发展迈进。业内认为，这为市场提供了清晰的政策预期。",
    ],
  },
  {
    id: "i02",
    section: "industry",
    category: "行业",
    title: "月度汽车销量数据出炉，新能源渗透率再创新高",
    summary: "最新产销数据显示，新能源乘用车渗透率继续攀升，自主品牌市场份额稳步扩大。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20bright%20modern%20data%20visualization%20wall%20with%20rising%20charts%20in%20an%20office%2C%20soft%20daylight%2C%20clean%20neutral%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=ind-02&orientation=landscape",
    author: "行业组 · 周珂",
    date: "2026-10-11",
    readTime: 5,
    views: 21560,
    tags: ["行业", "销量", "市场", "数据"],
    brand: "市场",
    level: "宏观",
    content: [
      "最新公布的产销数据显示，汽车市场整体保持平稳增长，其中新能源乘用车的渗透率继续攀升，创下新的阶段高点。",
      "从品牌结构看，自主品牌凭借新能源产品持续扩大市场份额，合资品牌则在加速电动化转型以应对挑战。出口市场依旧是增长亮点。",
      "分析人士指出，价格竞争的持续以及产品供给的丰富，是推动渗透率提升的重要原因。未来市场的分化可能进一步加剧。",
    ],
  },
  {
    id: "i03",
    section: "industry",
    category: "行业",
    title: "动力电池回收利用新规正式实施",
    summary: "动力电池回收利用管理办法落地，明确全生命周期管理要求，推动产业链绿色循环。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20clean%20modern%20recycling%20facility%20with%20battery%20modules%20on%20conveyor%2C%20soft%20daylight%2C%20clean%20neutral%20industrial%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20green%20tones&width=800&height=600&seq=ind-03&orientation=landscape",
    author: "行业组 · 陈默",
    date: "2026-10-10",
    readTime: 4,
    views: 14320,
    tags: ["行业", "电池", "回收", "政策"],
    brand: "政策",
    level: "产业链",
    content: [
      "动力电池回收利用相关新规正式实施，对电池从生产、使用到回收的全生命周期提出了更明确的管理要求，推动产业链绿色循环。",
      "新规鼓励企业建立可追溯的回收体系，提升关键材料的回收利用率，减少资源浪费与环境风险。相关部门将加强监管与标准建设。",
      "业内认为，随着早期新能源车陆续进入退役期，动力电池回收将成为新的产业热点，回收体系是否完善将直接影响产业的可持续性。",
    ],
  },
  {
    id: "i04",
    section: "industry",
    category: "行业",
    title: "多家车企宣布价格调整，市场竞争持续升级",
    summary: "新一轮价格调整覆盖多个细分市场，行业竞争加剧，消费者购车门槛进一步降低。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20busy%20modern%20auto%20dealership%20showroom%20with%20several%20cars%2C%20soft%20bright%20lighting%2C%20clean%20neutral%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20neutral%20tones&width=800&height=600&seq=ind-04&orientation=landscape",
    author: "行业组 · 苏晴",
    date: "2026-10-09",
    readTime: 4,
    views: 24890,
    tags: ["行业", "价格", "竞争", "市场"],
    brand: "市场",
    level: "宏观",
    content: [
      "近期多家车企陆续宣布价格调整，涉及燃油车与新能源车多个细分市场。业内普遍认为，这是市场竞争持续升级的直接体现。",
      "价格调整的背后，是产能快速扩张与产品供给丰富带来的竞争压力。部分企业通过优化配置、推出更具性价比的版本参与竞争。",
      "对消费者而言，价格的下探降低了购车门槛；但对车企而言，如何在利润与份额之间取得平衡，将成为长期的考验。",
    ],
  },
  {
    id: "i05",
    section: "industry",
    category: "行业",
    title: "智能网联汽车标准体系加速完善",
    summary: "智能网联汽车相关标准密集出台，为高级别自动驾驶的落地应用提供规范支撑。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20self%20driving%20test%20vehicle%20with%20sensors%20on%20a%20city%20road%2C%20soft%20daylight%2C%20clean%20neutral%20urban%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20modern%20tones&width=800&height=600&seq=ind-05&orientation=landscape",
    author: "行业组 · 何宇",
    date: "2026-10-08",
    readTime: 5,
    views: 16740,
    tags: ["行业", "智能网联", "标准", "自动驾驶"],
    brand: "技术",
    level: "宏观",
    content: [
      "智能网联汽车领域的标准体系正在加速完善，近期多项与数据安全、功能安全及自动驾驶测试相关的标准相继发布。",
      "标准的健全为高级别自动驾驶的规模化落地提供了规范支撑，有助于统一技术要求、降低跨企业协同成本，也增强了公众对技术的信任。",
      "业界普遍认为，随着标准体系逐步成形，智能网联汽车将从示范应用走向更大范围的商业化落地，产业链相关企业有望受益。",
    ],
  },
  {
    id: "i06",
    section: "industry",
    category: "行业",
    title: "充电基础设施建设提速，公共补能网络持续加密",
    summary: "各地加快充电桩布局，高速与城市公共快充比例提升，补能便利性持续改善。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20highway%20service%20area%20with%20modern%20fast%20charging%20stations%20and%20electric%20cars%2C%20soft%20daylight%2C%20clean%20neutral%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20bright%20tones&width=800&height=600&seq=ind-06&orientation=landscape",
    author: "行业组 · 郑楠",
    date: "2026-10-07",
    readTime: 4,
    views: 15280,
    tags: ["行业", "充电", "基础设施", "补能"],
    brand: "基建",
    level: "产业链",
    content: [
      "各地正加快充电基础设施建设，高速公路服务区与城市公共区域的快充桩数量明显增加，补能网络持续加密。",
      "随着大功率超充技术的普及，单次补能时间进一步缩短，用户在节假日高峰期的排队压力有所缓解。多个城市也在推动小区充电设施改造。",
      "业内指出，补能便利性是影响新能源车使用体验的关键因素。基础设施的完善将有助于进一步提升消费者的购买意愿。",
    ],
  },
  {
    id: "i07",
    section: "industry",
    category: "行业",
    title: "中国品牌加速出海，海外市场份额稳步提升",
    summary: "自主品牌通过本地化生产与渠道建设，加快海外市场布局，出口结构持续优化。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20cargo%20ship%20loaded%20with%20new%20cars%20at%20a%20modern%20port%20at%20dusk%2C%20soft%20ambient%20light%2C%20clean%20neutral%20industrial%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20cool%20tones&width=800&height=600&seq=ind-07&orientation=landscape",
    author: "行业组 · 林一",
    date: "2026-10-06",
    readTime: 5,
    views: 17420,
    tags: ["行业", "出海", "出口", "市场"],
    brand: "市场",
    level: "宏观",
    content: [
      "中国汽车品牌正加速拓展海外市场，通过本地化生产、渠道建设与品牌运营提升竞争力，海外市场份额稳步提升。",
      "从出口结构看，新能源车型占比持续提高，欧洲、东南亚与中东成为重要的增长区域。多家企业已在海外设立工厂或研发中心。",
      "出海既是机遇也是挑战，企业需要应对不同市场的法规、关税与消费者偏好差异。能否实现从产品输出到品牌输出的跨越，将是关键。",
    ],
  },
  {
    id: "i08",
    section: "industry",
    category: "行业",
    title: "L3级自动驾驶试点范围进一步扩大",
    summary: "多个城市扩大高级别自动驾驶试点，相关法规配套逐步跟进，商业化路径日渐清晰。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20an%20autonomous%20test%20car%20with%20roof%20sensors%20on%20a%20futuristic%20city%20street%2C%20soft%20daylight%2C%20clean%20neutral%20urban%20background%2C%20crisp%20detail%2C%20professional%20magazine%20composition%2C%20modern%20cool%20tones&width=800&height=600&seq=ind-08&orientation=landscape",
    author: "行业组 · 苏晴",
    date: "2026-10-05",
    readTime: 5,
    views: 19860,
    tags: ["行业", "自动驾驶", "试点", "法规"],
    brand: "技术",
    level: "宏观",
    content: [
      "高级别自动驾驶的试点范围进一步扩大，多个城市开放了更多测试道路与场景，为 L3 级自动驾驶的验证与落地创造了条件。",
      "配套法规也在逐步跟进，涉及责任认定、数据记录与安全冗余等方面。清晰的规则是自动驾驶从测试走向商业化的前提。",
      "业内认为，L3 级自动驾驶的商业化将是一个渐进过程，技术、法规与用户接受度需要同步成熟。率先跑通闭环的企业将占据先机。",
    ],
  },
];